export const ASSET_REQUEST_SUCCESS = 'ASSET_REQUEST_SUCCESS';
export const ASSET_REQUEST_ERROR = 'ASSET_REQUEST_ERROR';
export const ASSET_REQUEST_LOADING = 'ASSET_REQUEST_LOADING';
